import { Button } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useTranslation } from "react-i18next";
import Barcode from "react-barcode/lib/react-barcode";
import { PrintDiv } from "../../hooks/Method";

function BarcodeGen(props) {
  const { t } = useTranslation();
  const { value, setShowPopup } = props;
  const handlePrint = () => {
    PrintDiv("barcodeCanva");
  };
  return (
    <Box className="p-15">
      <Box
        className="tx-center mb-20"
        id="barcodeCanva"
        sx={{ overflow: "auto" }}
      >
        <Barcode value={value} />
      </Box>
      <Box
        className="w-100pr d-flex"
        sx={{ flexWrap: { md: "inherit", xs: "wrap" } }}
      >
        <Button
          onClick={handlePrint}
          type="submit"
          fullWidth
          className="btn-primary w-100pr"
          size="large"
        >
          {t("print")}
        </Button>
        <Button
          onClick={() => setShowPopup(false)}
          className="btn-error w-100pr"
          size="large"
          sx={{ ml: { md: "10px" }, mt: { xs: "15px", md: "0px" } }}
        >
          {t("close")}
        </Button>
      </Box>
    </Box>
  );
}

export default BarcodeGen;
